import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import {
  NbDialogRef,
  NbDialogService,
  NbLayoutScrollService,
  NbMenuItem,
} from "@nebular/theme";
import { Subject } from "rxjs";
import { filter, map, takeUntil } from "rxjs/operators";
import CourseSection, {
  SectionLecture,
} from "../../models/course-content.model";
import Course from "../../models/course.model";
import LectureContent from "../../models/lecture-content.model";
import { CourseContentService } from "../../services/course-content.service";
import { LectureContentService } from "../../services/lecture-content.service";

@Component({
  selector: "ngx-dialog-preview-course",
  templateUrl: "dialog-preview-course.component.html",
  styleUrls: ["dialog-preview-course.component.scss"],
})
export class DialogPreviewCourseComponent implements OnInit, OnDestroy {
  private destroy$: Subject<void> = new Subject<void>();
  @Input() course: Course = new Course();
  @Input() courseId?: string = "";
  sections?: CourseSection[];
  content: LectureContent = new LectureContent();

  selectedLecture: SectionLecture = new SectionLecture();

  loading = false;
  loadingS = false;

  lectureContentId = "";
  sourceType = "";
  sourceId = "";

  constructor(
    protected ref: NbDialogRef<DialogPreviewCourseComponent>,
    private courseContentService: CourseContentService,
    private contentService: LectureContentService,
    private scrollService: NbLayoutScrollService
  ) {}

  ngOnInit() {
    if (this.courseId != "") {
      this.getSections();
    }
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  close() {
    this.ref.close();
  }

  getSections(): void {
    this.loadingS = true;
    this.courseContentService
      .getSections(this.courseId)
      .snapshotChanges()
      .pipe(
        map((changes) =>
          changes.map((c) => ({
            id: c.payload.doc.id,
            ...c.payload.doc.data(),
          }))
        ),
        takeUntil(this.destroy$)
      )
      .subscribe((data) => {
        this.loadingS = false;
        this.sections = data;
      });
  }

  openSourceContent(item: SectionLecture) {
    this.selectedLecture = item;
    this.sourceType = item.sourceType;
    this.lectureContentId = item.lectureContentId;
    if (this.lectureContentId != "") {
      this.loading = true;
      this.contentService
        .get(this.lectureContentId)
        .pipe(takeUntil(this.destroy$))
        .subscribe((data) => {
          this.content = data;
          this.content.id = this.lectureContentId;

          this.loading = false;
        });
    }

    // Scrolling back to the top
    this.scrollService.scrollTo(0, 0);
  }
}
